import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-configurator-input-field',
  templateUrl: './input-field.component.html'
})
export class InputFieldComponent {
  @Input() label: string = '';
  @Input() labelID: string = '';
  @Input() suffix: string = '';
  @Input() initialValue: string = '';

  isEmptyString = (data: string): boolean => data.trim().length === 0;

  constructor() {}
}
